__turbopack_context__.v({
  "banner": "Banner-module__7Eya9q__banner",
  "bannerContainer": "Banner-module__7Eya9q__bannerContainer",
  "headerTekstogVelger": "Banner-module__7Eya9q__headerTekstogVelger",
  "innerBanner": "Banner-module__7Eya9q__innerBanner",
});
